export default __webpack_public_path__ + "static/per-marker-customisation-bcd5f0658597ba19c64232af5a04bb56.png";